module.exports = __webpack_public_path__ + "media/application/images/svgs/rss-7b5172ca5c6981ef7d6894b37a34d941.svg";